<template>
  <div class="kanban-header">
    <div
      v-for="(item, itemIndex) in headerItems"
      class="kanban-header-item"
      :key="`${item.value}-${itemIndex}`"
    >
      <div class="details">
        <div class="text header-label">{{ item.label }}</div>
        <div class="text count">
          {{ groupedTasks[item.value]?.length || 0 }}
        </div>
      </div>
      <img
        v-if="canAddItem && canCreateItemInColumn(item)"
        class="add-item"
        src="../../assets/img/muted-plus-icon.svg"
        @click="$emit('onAddNewItem', item.value)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'KanbanHeader',
  props: {
    headerItems: { type: Array, default: () => [] },
    groupedTasks: { type: Object, default: () => ({}) },
    canAddItem: { type: Boolean, default: false },
    statusFieldRequired: { type: Boolean, default: false },
  },
  methods: {
    canCreateItemInColumn(item) {
      return !(this.statusFieldRequired && item?.value === 'nostatus');
    },
  },
};
</script>
<style scoped>
.kanban-header {
  position: sticky;
  top: 0;
  background: white;
  width: fit-content;
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 36px;
  z-index: 12;
  margin-bottom: 8px;
  padding-right: 10px;
}

.kanban-header .kanban-header-item {
  display: flex;
  justify-content: space-between;
  width: 315px;
  max-width: 315px;
  min-width: 315px;
  box-sizing: border-box;
}

.kanban-header .kanban-header-item:first-child {
  padding-left: 8px;
}

.kanban-header .kanban-header-item .details {
  display: flex;
  justify-content: start;
  align-items: center;
}

.kanban-header-item .text {
  font-family: 'AktivGroteskMedium';
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #636381;
}

.kanban-header-item .add-item {
  margin-right: 10px;
  cursor: pointer;
}

.kanban-header .kanban-header-item .count {
  /* background: #f2efef; */
  min-width: 34px;
  min-height: 34px;
  padding: 4px 10px;
  line-height: 1;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #636381;
  font-family: 'AktivGroteskMedium';
  font-size: 16px;
  font-weight: 500;
  height: 34px;
  margin-left: 12px;
}

.kanban-header .kanban-header-item .header-label {
  max-width: 80%;
  color: #636381;
  font-family: 'AktivGroteskMedium';
  font-size: 16px;
  font-weight: 500;
}
</style>
